import { useState } from 'react';

const useCustomHook = () => {
  const [isLoading, setIsLoading] = useState(true);

  return {
    isLoading,
    setIsLoading,
  };
};

export default useCustomHook;
